import Image from 'next/image';
import * as React from 'react';

export interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  className?: string;
  src: string;
  width: string;
  height: string;
  placeholder?: 'blur' | 'empty';
}

const NextImage: React.FC<ImageProps> = ({ width: _width, height: _height, src, alt, className, title, ...props }) => {
  const [width, height] = [_width, _height].map(value => parseInt(value));

  // fixme: Fix nginx 502 Bad Gateway for Next/Image
  if (!!width && !isNaN(width) && !!height && !isNaN(height)) {
    return (
      <Image
        width={width}
        height={height}
        src={src}
        alt={typeof alt === 'string' ? alt : ''}
        className={className}
        placeholder="blur"
        loading="lazy"
        blurDataURL={src}
        title={typeof title === 'string' ? title : undefined}
        {...props}
      />
    );
  } else {
    return (
      // eslint-disable-next-line @next/next/no-img-element
      <img
        src={src}
        alt={typeof alt === 'string' ? alt : ''}
        title={typeof title === 'string' ? title : undefined}
        className={className}
        {...props}
      />
    );
  }
};

export default NextImage;
